import React, { useEffect, useState } from "react";
import { Profile } from "../Profile/Profile";
import { Card } from "../card";
import InputField from "../input/inputField";
import Dropdown from "../Dropdown/dropdown";
import { GENDER_OPTIONS } from "../../Constants/options/gender.options";
import { getSelectedOptionFromValue } from "../../Helper/options.helper";
import { DateField } from "../input/DateField";
import { BtnType, Button } from "../Button";
import { useGetClassesOptions } from "../../hooks/classHooks/class.hooks";
import { useGetSchoolBranchesOptions } from "../../hooks/branchHooks/branch.hooks";
import { useUpdateStudentInfo } from "../../hooks/students/useUpdateStudent.hooks";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import {
  BRANCH_ID_REQUIRED,
  CLASS_ID_REQUIRED,
  DOB_REQUIRED,
  FIRST_NAME_REQUIRED,
  GENDER_REQUIRED,
  LAST_NAME_REQUIRED,
} from "../../Constants/Message/Student.messages";
import { useDispatch } from "react-redux";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useGetTransportOptions } from "../../hooks/transportHook/transport.hooks";
import { DropdownOptions } from "../dropdownOptions";
import { NepaliDateField } from "../input/NepaliDateField";
import {
  convertADToBS,
  formatDateBasedOnTimezone,
} from "../../utils/date.utils";
import { AdBsCalendar } from "../Calendar/AdBsCalendar";
import { STANDARD_DATE_FORMAT } from "../../Constants/date";
interface Props {
  studentInfo: any;
  studentId: number;
}
export const StudentInfo = ({ studentInfo, studentId }: Props) => {
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState<string>("");
  const [middleName, setMiddleName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [dob, setDOB] = useState<string>("");
  const [_class, setClass] = useState<number | null>(null);
  const [branch, setBranch] = useState<number | null>(null);
  const [gender, setGender] = useState<string>("");
  const [rollNo, setRollNo] = useState<string | null>(null);
  const [religion, setReligion] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [nationality, setNationality] = useState<string>("");
  const [transportId, setTreansportId] = useState<number | null>(null);
  const [registeredAt, setRegisteredAt] = useState<string>("");

  console.log(studentInfo);

  const initializeStudentInfo = () => {
    setFirstName(studentInfo?.first_name || "");
    setMiddleName(studentInfo?.middle_name || "");
    setLastName(studentInfo?.last_name || "");
    setDOB(studentInfo?.date_of_birth || "");
    setClass(studentInfo?.class?.id || "");
    setBranch(studentInfo?.school_branch.id || "");
    setGender(studentInfo?.gender || "");
    setTreansportId(studentInfo?.transport_id || null);
    setAddress(studentInfo?.address || "");
    setNationality(studentInfo?.nationality || "");
    setReligion(studentInfo?.religion || "");
    setRollNo(studentInfo?.roll_no || "");

    const formattedRegisteredAt = formatDateBasedOnTimezone({
      date: studentInfo?.registered_at || "",
      formatType: STANDARD_DATE_FORMAT,
    });
    setRegisteredAt(formattedRegisteredAt);
  };

  const { data: TRANSPORT_OPTIONS } = useGetTransportOptions();

  useEffect(() => {
    initializeStudentInfo();
  }, []);

  // const { isLoading: isUpdatingStudentInfo, mutate: updateStudentInfo } =
  //   useUpdateStudentInfo({
  //     studentId: studentId,
  //   });

  const { isLoading: isClassOptionsLoading, data: CLASSES_OPTIONS } =
    useGetClassesOptions();

  const { isLoading: isBranchOptionsLoading, data: BRANCHES_OPTIONS } =
    useGetSchoolBranchesOptions();

  const { isLoading: isUpdatingStudent, mutate: updateStudent } =
    useUpdateStudentInfo({
      studentId: studentInfo.id,
    });

  const validateStudentInfo = () => {
    if (!firstName) {
      dispatch(setWarningMessage(FIRST_NAME_REQUIRED));
      return false;
    }
    if (!lastName) {
      dispatch(setWarningMessage(LAST_NAME_REQUIRED));
      return false;
    }
    if (!_class) {
      dispatch(setWarningMessage(CLASS_ID_REQUIRED));
      return false;
    }
    if (!branch) {
      dispatch(setWarningMessage(BRANCH_ID_REQUIRED));
      return false;
    }
    if (!dob) {
      dispatch(setWarningMessage(DOB_REQUIRED));
      return false;
    }
    if (!gender) {
      dispatch(setWarningMessage(GENDER_REQUIRED));
      return false;
    }
    return true;
  };

  const onStudentInfoUpdate = () => {
    if (!validateStudentInfo()) return;

    const payload = {
      firstName,
      middleName,
      lastName,
      branchId: branch as number,
      classId: _class as number,
      dateOfBirth: dob,
      gender,
      transportId: transportId as number,
      registeredAt,
      address,
      rollNo: rollNo?.trim() ? rollNo.trim() : null,
    };

    updateStudent(payload, {
      onSuccess: () => {
        dispatch(
          setSuccessMessage("Student info has been successfully updated."),
        );
      },
      onError: (error: any) => {
        dispatch(
          setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG),
        );
      },
    });
  };

  if (isClassOptionsLoading || isBranchOptionsLoading) {
    return <></>;
  }

  const BSDate = convertADToBS(dob || studentInfo?.date_of_birth);

  const setBSDate = ({
    bsDate,
    adDate,
  }: {
    bsDate: string;
    adDate: string;
  }) => {
    setDOB(adDate);
  };

  return (
    <Card>
      <Profile>
        <div className="w-3/4">
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-8">
            <InputField
              value={firstName}
              setValue={(value) => {
                setFirstName(value);
              }}
              label="First name"
            />
            <InputField
              value={middleName}
              setValue={(value) => {
                setMiddleName(value);
              }}
              label="Middle name"
            />
            <InputField
              value={lastName}
              setValue={(value) => {
                setLastName(value);
              }}
              label="Last name"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-8">
            <InputField
              value={rollNo || ""}
              setValue={(value) => {
                setRollNo(value);
              }}
              label="Roll no"
            />
            <DateField
              date={dob}
              setDate={(value) => {
                setDOB(value);
              }}
              label="Date of birth (A.D)"
            />

            <NepaliDateField
              date={BSDate}
              setDate={setBSDate}
              label="Date of birth (B.S)"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-8">
            <Dropdown
              label="Branch"
              options={BRANCHES_OPTIONS || []}
              selectedOption={getSelectedOptionFromValue(
                BRANCHES_OPTIONS || [],
                branch,
              )}
              setSelectedOption={(option) => {
                setBranch(option.value as number);
              }}
              // wrapperStlye={{ flex: 1 }}
            />

            <Dropdown
              label="Class"
              options={CLASSES_OPTIONS || []}
              selectedOption={getSelectedOptionFromValue(
                CLASSES_OPTIONS || [],
                _class,
              )}
              setSelectedOption={(option) => {
                setClass(option.value as number);
              }}
              // wrapperStlye={{ flex: 1 }}
            />

            <AdBsCalendar
              date={registeredAt}
              setDate={(value) => setRegisteredAt(value)}
              title={"Registered at"}
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-8">
            <InputField
              value={address}
              setValue={(value) => {
                setAddress(value);
              }}
              label="Address"
            />
            <InputField
              value={religion}
              setValue={(value) => {
                setReligion(value);
              }}
              label="Religion"
            />
            <InputField
              value={nationality}
              setValue={(value) => {
                setNationality(value);
              }}
              label="Nationality"
            />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-x-8">
            <Dropdown
              label="Gender"
              options={GENDER_OPTIONS}
              selectedOption={getSelectedOptionFromValue(
                GENDER_OPTIONS,
                gender,
              )}
              setSelectedOption={(option) => {
                setGender(option.value as string);
              }}
              wrapperStlye={{ flex: 1 }}
            />

            <Dropdown
              label="Transportation"
              options={TRANSPORT_OPTIONS || []}
              selectedOption={
                (TRANSPORT_OPTIONS || []).find(
                  ({ value }: { value: number | null }) =>
                    value === transportId,
                ) as DropdownOptions
              }
              setSelectedOption={(selectedOption: DropdownOptions) => {
                setTreansportId(selectedOption.value as number);
              }}
              wrapperStlye={{ flex: 1 }}
              canBeEmpty
            />
          </div>
          <div className="mt-12">
            <Button
              btnType={BtnType.primary}
              text="Save"
              loading={isUpdatingStudent}
              onClick={onStudentInfoUpdate}
            />
          </div>
        </div>
      </Profile>
    </Card>
  );
};
